import { ProfilePageSkeleton } from "#components/pages";
import { LoaderFunctionArgs, useLoaderData, useOutletContext } from "react-router";
import { OutletContext } from "./creator-page";
import { fetchRecommendedCreators } from "#api/profiles/recommended";
import { ArtistCard, CardList } from "#components/cards";
import { ARTISTS_OR_CREATORS } from "#env/env-vars";

interface IProps {
  recommendedCreators: Awaited<ReturnType<typeof fetchRecommendedCreators>>;
}

export function RecommendedCreatorsPage() {
  const { creator } = useOutletContext() as OutletContext;
  const { recommendedCreators } = useLoaderData() as IProps;
  const title = `Recommended ${ARTISTS_OR_CREATORS}`;

  return (
    <ProfilePageSkeleton creator={creator} name={["user", "recommended"]} title={title}>
      <CardList layout="phone">
        {recommendedCreators.length === 0 ? (
          <p className="subtitle card-list__item--no-results">
            No similar artists found.
          </p>
        ) : (
          recommendedCreators.map((creator) =>
            <ArtistCard
              key={`${creator.service}-${creator.id}`}
              artist={creator}
            />
          )
        )}
      </CardList>
    </ProfilePageSkeleton>
  )
}

export async function loader({ params }: LoaderFunctionArgs): Promise<IProps> {
  const service = params.service!.trim();
  const creatorId = params.creatorId!.trim();

  const recommendedCreators = fetchRecommendedCreators(service, creatorId);

  return {
    recommendedCreators: await recommendedCreators,
  };
}
